import { styled } from '@mui/material';

interface DynamicLayoutProps {
  header: React.ReactNode;
  main: React.ReactNode;
  aside: React.ReactNode;
}

export const DynamicLayout: React.FC<DynamicLayoutProps> = ({ header, main, aside }) => {
  const hasAsideContent = () => {
    if (!aside) return false;
    if (Array.isArray(aside)) {
      return aside.length > 0;
    }
    return true;
  };

  const hasHeaderContent = () => {
    if (!header) return false;
    if (Array.isArray(header)) {
      return header.length > 0;
    }
    return true;
  };

  return (
    <>
      {hasHeaderContent() && <StyledHeader>{header}</StyledHeader>}
      <LayoutWrapper>
        <StyledMain>{main}</StyledMain>
        {hasAsideContent() && <StyledAside>{aside}</StyledAside>}
      </LayoutWrapper>
    </>
  );
};

const LayoutWrapper = styled('div')`
  display: flex;
  width: 100%;
  justify-content: center;
  gap: 24px;

  @media (max-width: 767px) {
    flex-direction: column-reverse;
  }
`;

const StyledHeader = styled('div')`
  width: 100%;
  max-width: 840px;
  margin: 0 auto;
`;

const StyledMain = styled('div')`
  flex: 1;
  width: 100%;
  max-width: 840px;
  margin: 0 auto;
`;

const StyledAside = styled('div')`
  width: 264px;
  position: sticky;
  top: calc(var(--app-header-height) + 20px);
  align-self: flex-start;
  flex-shrink: 0;

  @media (max-width: 767px) {
    position: static;
    margin: 0 auto;
    width: 100%;
  }
`;
